import React from 'react';
import { useHistory } from 'react-router-dom';
import useSWR from 'swr';
import { Loader } from '../../components/loader/Loader';
import { useAuth } from '../../contexts/auth';
import { UserRoles } from '../../types/applicationUser.types';
import { Dashboard } from '../../types/dashboard.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { userHasAccess } from '../../utils/userHasAccess';
import DashboardBlock from './DashboardBlock';

export default function DashboardPage() {
  const { user } = useAuth();
  const history = useHistory();
  const { data: dashboards, isValidating: loadingDashboards } = useSWR<Dashboard[]>(
    `${API_URL.DASHBOARDS_DESKTOP_LIST}`,
    fetcher,
  );

  if (loadingDashboards || !user) return <Loader />;
  return (
    <div className={'content-block'}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'stretch ' }}>
        {dashboards?.map((dashboard: Dashboard, i) => {
          const hasAccess = userHasAccess(
            user.roles,
            dashboard.transactionOnClick?.requiredRole?.split(',') as UserRoles[],
          );

          return (
            <span
              style={{
                width: `${dashboard.width}%`,
                alignSelf: 'flex-start',
                display: 'inline-block',
                cursor: dashboard.transactionOnClick && hasAccess ? 'pointer' : 'normal',
              }}
              key={dashboard.id}
              onClick={() => {
                if (!dashboard.transactionOnClick || !hasAccess) return;
                let url: string = dashboard.transactionOnClick.url;
                if (dashboard.reportSettingId)
                  url = url
                    .replace(':generalReportSettingId?', dashboard.reportSettingId.toString())
                    .replace(':settingId?', dashboard.reportSettingId.toString());
                else url = url.replace('/:generalReportSettingId?', '').replace('/:settingId?', '');

                history.push(url);
              }}
            >
              <DashboardBlock
                {...dashboard}
                style={dashboard.style ? JSON.parse(dashboard.style.toString()) : null}
              />
            </span>
          );
        })}
      </div>
    </div>
  );
}
